import { TabListState } from 'react-stately'

import { createContextAndHook } from '../utils/create-context'

export const [TabListStateContext, useTabListStateContext] =
  createContextAndHook<TabListState<object>>()
